var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 200,
    fill: "#c7d0de"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 20,
    y: 15,
    width: 80,
    height: 80,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:building-4-fill",
    clipPath: "url(#clip0_12174_3386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2914 7.41561C35.3675 7.10722 34.3877 7.00244 33.4195 7.10847C32.4512 7.2145 31.5174 7.52882 30.6821 8.02986L16.7771 16.3729C15.7776 16.9726 14.9504 17.8209 14.3761 18.8352C13.8018 19.8496 13.5 20.9954 13.5 22.161V67.5007H10.125C9.22989 67.5007 8.37145 67.8563 7.73851 68.4892C7.10558 69.1222 6.75 69.9806 6.75 70.8757C6.75 71.7708 7.10558 72.6293 7.73851 73.2622C8.37145 73.8952 9.22989 74.2507 10.125 74.2507H70.875C71.7701 74.2507 72.6286 73.8952 73.2615 73.2622C73.8944 72.6293 74.25 71.7708 74.25 70.8757C74.25 69.9806 73.8944 69.1222 73.2615 68.4892C72.6286 67.8563 71.7701 67.5007 70.875 67.5007H67.5V22.6807C67.4992 21.265 67.0532 19.8854 66.2253 18.7371C65.3973 17.5888 64.2293 16.7298 62.8864 16.2817L36.2914 7.41561ZM30.375 16.0894L20.25 22.1644V67.5007H30.375V16.086V16.0894Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12174_3386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 81,
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingRound);
export default __webpack_public_path__ + "static/media/building_round.20a71f7c3219e79789e5a1e41ed19267.svg";
export { ForwardRef as ReactComponent };